import React from "react";
import { List, ListItem, ListItemText, Typography } from "@mui/material";

const alertsMock = [
  {
    id: 1,
    type: "Landslide",
    location: "Solan Bypass",
    desc: "Road blocked due to landslide",
    status: "Active",
  },
  {
    id: 2,
    type: "Road Work",
    location: "Kullu-Manali Road",
    desc: "Diversion in place",
    status: "Active",
  },
  // Add more alerts if needed
];

export default function Alerts() {
  return (
    <div>
      <Typography variant="h5" gutterBottom>
        Current Road & Bus Alerts
      </Typography>
      <List>
        {alertsMock.map((alert) => (
          <ListItem key={alert.id} sx={{ borderBottom: "1px solid #eee" }}>
            <ListItemText
              primary={`${alert.type} at ${alert.location}`}
              secondary={`${alert.desc} - ${alert.status}`}
            />
          </ListItem>
        ))}
      </List>
    </div>
  );
}
